type QueryParams = Record<string, string | number | undefined>;

const buildUrl = (path: string, query?: QueryParams): string => {
  if (!query) return path;

  const queryString = Object.entries(query)
    .flatMap(([key, value]) =>
      value !== undefined
        ? [`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`]
        : []
    )
    .join("&");

  return queryString ? `${path}?${queryString}` : path;
};

export const ROUTES = {
  RESTAURANT_REQUEST: "/devenir-partenaire",
  RIDER_REQUEST: "/devenir-coursier",
  AUTH_VERIFY_CODE: "/auth/verify-code",
  RESTAURANTS: "/restaurants",
  CURRENT_ORDERS: "/current-orders",
  ORDERS_HISTORY: "/history",
  PROFILE: "/profile",
} as const;

export function route(path: string, query?: QueryParams): string {
  return buildUrl(path, query);
}
